import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvier } from '../config-provider';
import Node from '../node';
import { StoreProvider } from '../store/storeProvier';
import { getStoreInstance } from '../store/storeInstance';

var Tree = function Tree(_ref) {
  var components = _ref.components,
      root = _ref.root,
      onClick = _ref.onClick,
      onImpression = _ref.onImpression;
  return _jsx(ConfigProvier, Object.assign({
    components: components,
    onClick: onClick,
    onImpression: onImpression
  }, {
    children: _jsx(StoreProvider, Object.assign({
      createStore: getStoreInstance
    }, {
      children: _jsx(Node, {
        id: root
      })
    }))
  }));
};

Tree.displayName = 'Tree';
Tree.defaultProps = {
  root: 'root'
};
export default Tree;